import { render, staticRenderFns } from "./LegalNotices.vue?vue&type=template&id=58ed176b&scoped=true&"
import script from "./LegalNotices.vue?vue&type=script&lang=js&"
export * from "./LegalNotices.vue?vue&type=script&lang=js&"
import style0 from "./LegalNotices.vue?vue&type=style&index=0&id=58ed176b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ed176b",
  null
  
)

export default component.exports